/* eslint-disable no-plusplus */
import * as React from "react";
import { useEffect, useState } from "react";
import unique from "../../../../Utils/Unique";
import TextInput from "../../../../Layout/Inputs/TextInput";

export function CrossingCountries({ ltlPipeline }: { ltlPipeline: any }) {
  const [crossingCountries, setCrossingCountries] = useState("");

  useEffect(() => {
    if (!ltlPipeline) {
      throw new Error("LtlPipeline is undefined!");
    }
    setCrossingCountriesStr();
  }, [ltlPipeline]);

  const setCrossingCountriesStr = () => {
    const crossingCountries = [];

    if (ltlPipeline && ltlPipeline.routing) {
      for (let i = 0; i < ltlPipeline.routing.length; i++) {
        const routing = ltlPipeline.routing[i];

        if (routing && routing.Route) {
          if (
            routing.Route.CrossingCountries === undefined ||
            routing.Route.CrossingCountries === null
          ) {
            break;
          }

          for (let j = 0; j < routing.Route.CrossingCountries.length; j++) {
            const crossingCountry = routing.Route.CrossingCountries[j];
            crossingCountries.push(crossingCountry);
          }
        }
      }
    }

    const crossingCountriesStr = crossingCountries?.filter(unique).join(", ");
    setCrossingCountries(crossingCountriesStr);
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {!ltlPipeline?.JitKanban ? (
        <TextInput
          label="Crossing Countries"
          disabled
          value={crossingCountries}
        />
      ) : (
        <div />
      )}
    </>
  );
}
